import styles from '@modules/modules/CookieConsent/CookieConsent.module.scss';
import Button from '@ui/components/Button/Button';
import Switch from '@ui/components/Switch/Switch';
import Content from '@ui/components/Content/Content';
import React, { useEffect, useRef, useState } from 'react';
import {
  Disclosure,
  DisclosureContent,
  FormCheckbox,
  useDisclosureStore,
} from '@ariakit/react';

const ConsentService = ({
  store,
  groupId,
  id,
  company,
  name,
  details,
  dependencies,
  via,
}) => {
  const contentRef = useRef(null);
  const [open, setOpen] = useState(false);
  const disclosure = useDisclosureStore({ open, setOpen });
  const { open: disclosureOpen, mounted } = disclosure.useState();
  const detailsText = `${details} ${dependencies && '<br />'} ${
    dependencies &&
    dependencies.map(
      dependency => `
        <h3>${dependency.name}</h3>
        <p>${dependency.details}</p>
      `,
    )
  }`;

  useEffect(() => {
    if (disclosureOpen && contentRef.current) {
      contentRef.current.focus();
    }
  }, [disclosureOpen]);

  return (
    <div className={styles.service}>
      <div className={styles.serviceContent}>
        <span className={styles.serviceTitle}>
          {name} {via && <span className={styles.via}>- {via}</span>}
        </span>
        <div className={styles.disclosureToggleWide}>
          <Disclosure
            render={<Button variant="link">Alle Details</Button>}
            store={disclosure}
          />
        </div>

        <FormCheckbox
          name={`${groupId}.${id}`}
          render={<Switch aria-label={`${name} akzeptieren`} value={id} />}
          store={store}
        />
      </div>
      <Content noSpacing>{company}</Content>
      <div className={styles.contentToggle}>
        <Disclosure
          render={<Button variant="link">Alle Details</Button>}
          store={disclosure}
        />
      </div>
      <DisclosureContent store={disclosure}>
        {mounted && (
          <Content
            className={styles.details}
            noSpacing
            ref={contentRef}
            size="md"
            tabIndex={-1}
            withParser
          >
            {detailsText}
          </Content>
        )}
      </DisclosureContent>
    </div>
  );
};

export default ConsentService;
